//https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch

const encode = (body: unknown) => JSON.stringify(body);

export const setBody = (body: unknown) => (request: Request) => new Request(
  request,
  { body: encode(body) },
);

export const setBodyFormData = (body: FormData) => (request: Request) => new Request(
  request,
  { body },
);
